/**
 * Tabs Component
 * Handles tab navigation and content switching
 */

export function initTabs() {
    const tabsContainers = document.querySelectorAll('.tabs');

    tabsContainers.forEach(container => {
        const buttons = container.querySelectorAll('.tab-button');
        const contents = container.querySelectorAll('.tab-content');

        // Set first tab as active by default if no active tab
        if (!container.querySelector('.tab-button.active')) {
            if (buttons[0]) buttons[0].classList.add('active');
            if (contents[0]) contents[0].classList.add('active');
        }

        buttons.forEach((button, index) => {
            button.addEventListener('click', () => {
                // Remove active class from all buttons and contents
                buttons.forEach(btn => btn.classList.remove('active'));
                contents.forEach(content => content.classList.remove('active'));

                // Add active class to clicked button and corresponding content
                button.classList.add('active');
                if (contents[index]) {
                    contents[index].classList.add('active');
                }

                // Update URL hash (optional, for bookmarkable tabs)
                const tabId = button.getAttribute('data-tab');
                if (tabId && history.replaceState) {
                    history.replaceState(null, null, `#${tabId}`);
                }
            });
        });

        // Check URL hash on page load
        const hash = window.location.hash.substring(1);
        if (hash) {
            const targetButton = container.querySelector(`[data-tab="${hash}"]`);
            if (targetButton) {
                targetButton.click();
            }
        }
    });
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabs);
} else {
    initTabs();
}
